import { StopPayment } from '@treasury/domain/stop-payments/stop-payment.entity';
import { format } from 'date-fns';

export class StopPaymentVm {
    constructor(protected stopPayment = new StopPayment()) {}

    public get id() {
        return this.stopPayment.id || 0;
    }

    public set id(id) {
        this.stopPayment.id = id;
    }

    public get account() {
        return this.stopPayment.account;
    }

    public get checkNumbers() {
        return this.stopPayment.checkNumbers || [];
    }

    public set checkNumbers(checkNumbers) {
        this.stopPayment.checkNumbers = checkNumbers;
    }

    public get checkDate() {
        return this.stopPayment.checkDate || '';
    }

    public set checkDate(checkDate) {
        this.stopPayment.checkDate = checkDate;
    }

    public get checkDateFormatted() {
        if (!this.checkDate) {
            return '';
        }
        return format(new Date(this.checkDate), 'MM/dd/yyyy');
    }

    public get checkAmount() {
        return this.stopPayment.checkAmount || 0;
    }

    public set checkAmount(checkAmount) {
        this.stopPayment.checkAmount = checkAmount;
    }

    public get checkAmountFormatted() {
        return this.checkAmount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }

    public get payee() {
        return this.stopPayment.payee || '';
    }

    public set payee(payee) {
        this.stopPayment.payee = payee;
    }

    public get remarks() {
        return this.stopPayment.remarks || [''];
    }

    public set remarks(remarks) {
        this.stopPayment.remarks = remarks;
    }

    public get status() {
        return this.stopPayment.status || '';
    }

    public get permissions() {
        return this.stopPayment.permissions || [];
    }

    public payment() {
        return this.stopPayment;
    }

    public get expirationDate() {
        return this.stopPayment.expirationDate || '';
    }

    public get expirationDateFormatted() {
        if (!this.expirationDate) {
            return '';
        }
        return format(new Date(this.expirationDate), 'MM/dd/yyyy');
    }

    public get enteredBy() {
        return this.stopPayment.enteredBy || '';
    }

    public get createdDate() {
        return this.stopPayment.createdDate || '';
    }

    public get createdDateFormatted() {
        if (!this.createdDate) {
            return '';
        }
        return format(new Date(this.createdDate), 'MM/dd/yyyy');
    }

    public get createdBy() {
        return this.stopPayment.createdBy || '';
    }

    public get totalApprovalsRequired() {
        return this.stopPayment.totalApprovalsRequired || 0;
    }

    public get numberOfApprovalsNeeded() {
        return this.stopPayment.totalApprovalsRequired || 0;
    }

    public get completedApprovalCount() {
        return this.stopPayment.numberOfApprovalsCompleted || 0;
    }

    public get sequenceNumber() {
        return this.stopPayment.sequenceNumber || '';
    }
}
